import React, { useState } from "react";
import { useParams } from "react-router";
import { useFederationEvents } from "hooks/events";
import { Heading, Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import styles from "./FederationEventsPage.module.styl";
import Pagination from "uikit/components/Pagination/Pagination";
import math from "lodash";
import FederationEventsView from "components/federationSummary/FederationEventsView/FederationEventsView";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";
import { Helmet } from "react-helmet-async";

export default function FederationEventsPage() {
    const pageSize = 20;

    const [payload, setPayload] = useState({ pageNumber: 1 });

    const { federationId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useFederationEvents(federationId, payload, {
        keepPreviousData: true,
    });

    const handlePageChange = (newPageNumber) => {
        setPayload((payload) => ({ ...payload, pageNumber: newPageNumber }));
    };

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader
                    position={"margin-auto"}
                    text={"Подождите. Данные загружаются."}
                    testName="loader-text"
                />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Мероприятия: ${data.federationName}`}
                    />
                    <meta name="application-name" content={`Мероприятия: ${data.federationName}`} />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/federation-summary/${federationId}`}
                        text={"Назад"}
                        name={"back-federation-events"}
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="federation-events-title">
                    Мероприятия: {data.federationName}
                </Heading>
                <FederationEventsView federationEvents={data.federationEvents} />
                {data.count > pageSize && (
                    <Pagination
                        pageCount={math.ceil(data.count / pageSize)}
                        forcePage={payload.pageNumber}
                        onPageChange={handlePageChange}
                        className={styles.pagination}
                    />
                )}
            </>
        );
    }
}
